import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send Via Email');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonText("Sending...");
    const subject = `${formDetails.firstName} ${formDetails.lastName ? formDetails.lastName : ''} - message from portfolio`;
    const body = `${formDetails.message}\n\n--\n${formDetails.firstName} ${formDetails.lastName ? formDetails.lastName : ''}\n${formDetails.phone ? 'Phone Number: ' + formDetails.phone + '\n' : ''}${formDetails.email ? 'Email Address: ' + formDetails.email : ''}`;
    const mailtoLink = `mailto:frisrsyd@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
    setButtonText("Send Via Email");
    setFormDetails(formInitialDetails);
  };

  const sendWhatsapp = () => {
    if (!formDetails.firstName || !formDetails.message) {
      setStatus({type: 'error', message: 'Please fill in your First Name and Message'});
      return;
    }
    const message = `${formDetails.message}\n\n--\n${formDetails.firstName} ${formDetails.lastName ? formDetails.lastName : ''}\n${formDetails.phone ? 'Phone Number: ' + formDetails.phone + '\n' : ''}${formDetails.email ? 'Email Address: ' + formDetails.email : ''}`;
    const whatsappLink = `https://wa.me/6285261297134?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  }

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} required/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.lasttName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)} required></textarea>
                    </Col>
                    {
                      status.type && 
                      <p className={`col-12 ${status.type === 'error' ? 'text-danger' : 'text-success'}`}>{status.message}</p>
                    }
                  </Row>
                  <Row>
                      <button className="col-md px-1 mx-1" type="submit"><span>{buttonText}</span></button>
                      <button className="col-md px-1 mx-1" onClick={() => sendWhatsapp()}><span>Send via WA</span></button>
                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
